export enum PageEnum {
  homePage = 'home_page',
  training = 'training',
  marketing = 'marketing',
}
